import request from '@/utils/request'

export interface PricingPreviewParams {
  pricingItem: string
  value: number
  validFrom?: string
  validTo?: string
  caretakerId?: string
}

export interface PricingOverlap {
  pricingId: string
  action: 'close' | 'trim_start' | 'delete'
  currentValidFrom: string
  currentValidTo: string | null
  resultingValidFrom: string | null
  resultingValidTo: string | null
}

export interface PricingPreviewResult {
  valid: boolean
  errors: string[]
  overlaps: PricingOverlap[]
}

export const previewOverlaps = (params: PricingPreviewParams): Promise<PricingPreviewResult> =>
  request({
    url: '/admin/pricings/preview',
    method: 'post',
    data: {
      pricing_item: params.pricingItem,
      value: params.value,
      valid_from: params.validFrom,
      valid_to: params.validTo,
      caretaker_id: params.caretakerId
    }
  }).then((res: any) => ({
    valid: res.valid,
    errors: res.errors,
    overlaps: (res.overlaps || []).map((o: any) => ({
      pricingId: o.pricing_id,
      action: o.action,
      currentValidFrom: o.current_valid_from,
      currentValidTo: o.current_valid_to,
      resultingValidFrom: o.resulting_valid_from,
      resultingValidTo: o.resulting_valid_to
    }))
  }))
